import React from "react";

class Resources extends React.Component {
	render() {
		return (
			<div id="resources" className="compResources">
				<div className="compWrapper">
					<section>
						<h3 className="compTitle">
							Resources.<span> All sorts of content to help you</span>
						</h3>
						<div>
							<h4>
								META PowerSchool{" "}
								<a href="https://www.youtube.com/channel/UCYEYZaEcvGs_UeYUV0dEimA/playlists">
									YouTube
								</a>{" "}
								Videos
							</h4>

							<div className="ytWrapper">
								<div>
									<div className="videoContainer">
										<iframe
											width="100%"
											height="100%"
											src="https://www.youtube.com/embed/BoMbO7_-mPw"
											title="YouTube video player"
											frameBorder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
											allowFullScreen
										></iframe>
									</div>
									<div className="vidInfo">
										<p className="contentCateg">Video Series</p>
										<p>
											<a
												href="https://www.youtube.com/watch?v=BoMbO7_-mPw&list=PLc5YC3mQTEF7itz_FHGAbx3rt9pPkAWh_"
												target="new"
											>
												2021-2022 Training Videos
											</a>
										</p>
									</div>
								</div>
								<div>
									<div className="videoContainer">
										<iframe
											width="100%"
											height="100%"
											src="https://www.youtube.com/embed/ebxtr3wGUKg"
											title="2023 March District Leader Meeting"
											frameBorder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
											allowFullScreen
										></iframe>
									</div>
									<div className="vidInfo">
										<p className="contentCateg">Virtual Meeting</p>
										<p>
											<a
												href="https://www.youtube.com/watch?v=1PPdfI7XgI0"
												target="new"
											>
												District Leader Meeting - March 2023
											</a>
										</p>
									</div>
								</div>
								<div>
									<div className="videoContainer">
										<iframe
											width="100%"
											height="100%"
											src="https://www.youtube.com/embed/aQBPlw-dn7E"
											title="YouTube video player"
											frameBorder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
											allowFullScreen
										></iframe>
									</div>
									<div className="vidInfo">
										<p className="contentCateg">Training Video</p>
										<p>
											<a
												href="https://www.youtube.com/watch?v=aQBPlw-dn7E&list=PLc5YC3mQTEF73ES3wvtl9pFITpr-XH4dL"
												target="new"
											>
												PowerTeacher Pro
											</a>
										</p>
									</div>
								</div>
								<div>
									<div className="videoContainer">
										<iframe
											width="100%"
											height="100%"
											src="https://www.youtube.com/embed/5XuvG-3nYHI"
											title="YouTube video player"
											frameBorder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
											allowFullScreen
										></iframe>
									</div>
									<div className="vidInfo">
										<p className="contentCateg">Training Video</p>
										<p>
											<a
												href="https://www.youtube.com/watch?v=5XuvG-3nYHI&list=PLc5YC3mQTEF7lK-M3HjNAJFM3mkgHFfuD"
												target="new"
											>
												META Customizations Catalog
											</a>
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		);
	}
}

export default Resources;

// import React from "react";

// class Resources extends React.Component {
//   render() {
//     return (
//       <div id="resources" className="compResources">
//         <div className="compWrapper">
//           <section>
//             <h3 className="compTitle">
//               Resources.<span> All sorts of content to help you</span>
//             </h3>
//             <div>
//               <h4>
//                 META PowerSchool{" "}
//                 <a href="https://www.youtube.com/channel/UCYEYZaEcvGs_UeYUV0dEimA/playlists">
//                   YouTube
//                 </a>{" "}
//                 Videos
//               </h4>

//               <div className="ytWrapper">
//                 <div>
//                   <div className="videoContainer">
//                     <iframe
//                       width="100%"
//                       height="100%"
//                       src="https://www.youtube.com/embed/BoMbO7_-mPw"
//                       title="YouTube video player"
//                       frameborder="0"
//                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                       allowfullscreen
//                     ></iframe>
//                   </div>
//                   <div className="vidInfo">
//                     <p className="contentCateg">Video Series</p>
//                     <p>
//                       <a
//                         href="https://www.youtube.com/watch?v=BoMbO7_-mPw&list=PLc5YC3mQTEF7itz_FHGAbx3rt9pPkAWh_"
//                         target="new"
//                       >
//                         2021-2022 Training Videos
//                       </a>
//                     </p>
//                     {/* <p className="contentDesc">Brief Description of the Video series</p> */}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="videoContainer">
//                     <iframe
//                       width="100%"
//                       height="100%"
//                       src="https://www.youtube.com/embed/ebxtr3wGUKg"
//                       title="2023 March District Leader Meeting"
//                       frameborder="0"
//                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//                       allowfullscreen
//                     ></iframe>
//                   </div>
//                   <div className="vidInfo">
//                     <p className="contentCateg">Virtual Meeting</p>
//                     <p>
//                       <a
//                         href="https://www.youtube.com/watch?v=1PPdfI7XgI0"
//                         target="new"
//                       >
//                         District Leader Meeting - March 2023
//                       </a>
//                     </p>
//                     {/* <p className="contentDesc">Brief Description of the Video series</p> */}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="videoContainer">
//                     <iframe
//                       width="100%"
//                       height="100%"
//                       src="https://www.youtube.com/embed/aQBPlw-dn7E"
//                       title="YouTube video player"
//                       frameborder="0"
//                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                       allowfullscreen
//                     ></iframe>
//                   </div>
//                   <div className="vidInfo">
//                     <p className="contentCateg">Training Video</p>
//                     <p>
//                       <a
//                         href="https://www.youtube.com/watch?v=aQBPlw-dn7E&list=PLc5YC3mQTEF73ES3wvtl9pFITpr-XH4dL"
//                         target="new"
//                       >
//                         PowerTeacher Pro
//                       </a>
//                     </p>
//                     {/* <p className="contentDesc">Brief Description of the Video series</p> */}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="videoContainer">
//                     <iframe
//                       width="100%"
//                       height="100%"
//                       src="https://www.youtube.com/embed/5XuvG-3nYHI"
//                       title="YouTube video player"
//                       frameborder="0"
//                       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                       allowfullscreen
//                     ></iframe>
//                   </div>
//                   <div className="vidInfo">
//                     <p className="contentCateg">Training Video</p>
//                     <p>
//                       <a
//                         href="https://www.youtube.com/watch?v=5XuvG-3nYHI&list=PLc5YC3mQTEF7lK-M3HjNAJFM3mkgHFfuD"
//                         target="new"
//                       >
//                         META Customizations Catalog
//                       </a>
//                     </p>
//                     {/* <p className="contentDesc">Brief Description of the Video series</p> */}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//         </div>
//       </div>
//     );
//   }
// }

// export default Resources;
